import React from 'react';
import {useNavigate} from 'react-router';
import type {TableConfiguration} from 'schema/table/types';
import type {Schema} from 'schemaDefinition/types';
import {
  ActiveMergeSuggestionTypes,
  type MergeSuggestion,
  type MergeSuggestionType,
} from 'services/mergeSuggestions/types';
import {useLocalization} from 'localization';
import {mapMergeSuggestionsToQueueItem, useSetMergeSuggestionQueue,} from 'services/mergeSuggestions';
import {useGetMergeSuggestionsQuery} from 'services/mergeSuggestions/mergeSuggestionsApi';
import {ActivityIndicator, FlexBox, Scene, Select} from 'components';
import {Table} from 'schema';

export const MergeSuggestionsSceneCore: React.FC = () => {
  const navigate = useNavigate();
  const {t} = useLocalization();

  const [type, setType] = React.useState<MergeSuggestionType>('SERIES');

  const {data, isLoading} = useGetMergeSuggestionsQuery({type});
  const setQueue = useSetMergeSuggestionQueue();

  const mergeSuggestionSchema: Schema<MergeSuggestion> = {
    name: 'mergeSuggestionSchema',
    parts: [
      {
        name: 'created',
        type: 'date',
      },
      {
        name: 'type',
        type: 'text',
      },
      {
        name: 'sourceId',
        type: 'text',
      },
      {
        name: 'targetId',
        type: 'text',
      },
      {
        name: 'description',
        type: 'text',
      },
    ],
  };

  const configuration: TableConfiguration<MergeSuggestion> = {
    partValueRenderers: {
      type: ({value}) =>
        t(`page.mergeSuggestion.type.${value as MergeSuggestionType}.label`),
    },
  };

  return (
    <Scene browserTitle={t('appbar.mergeOverview')}>
      <Scene.Header title={t('appbar.mergeOverview')} />
      <Scene.Content>
        <FlexBox mb={2} mt={2} width={'200px'}>
          <Select
            options={ActiveMergeSuggestionTypes.map(type => ({
              value: type,
              label: t(`page.mergeSuggestion.type.${type}.label`),
            }))}
            onChange={setType}
            value={type}
          />
        </FlexBox>
        {isLoading ? (
          <ActivityIndicator />
        ) : data ? (
          <FlexBox width={'1400px'}>
            <Table
              schema={mergeSuggestionSchema}
              data={data}
              header={null}
              configuration={configuration}
              onRowClick={row => {
                // @todo Increase beyond current pagination page size.
                setQueue(
                  data
                    // Exclude clicked item
                    .filter(s => s.id !== row.id)
                    .map(mapMergeSuggestionsToQueueItem),
                );
                if (row.type === 'SERIES') {
                  navigate(`/series/${row.sourceId}/merge/${row.targetId}`);
                } else if (row.type === 'WORK') {
                  navigate(`/work/${row.sourceId}/merge/${row.targetId}`);
                } else if (row.type === 'AGENT') {
                  navigate(`/agent/${row.sourceId}/merge/${row.targetId}`);
                }
              }}
            />
          </FlexBox>
        ) : (
          <div>En feil oppstod.</div>
        )}
      </Scene.Content>
    </Scene>
  );
};
